import Dexie from "dexie";

export const orchestratorDb = new Dexie("orchestratorDb");

orchestratorDb.version(1).stores({
    // 1 table stores all your cached datasets
    // key = "coveredEntities", value = { list, lastUpdatedAt, version }
    cache: "&key",
});

export async function readCache(key) {
    return await orchestratorDb.cache.get(key);
}

// Write
export async function writeCache(key, value) {
    await orchestratorDb.cache.put({ key, ...value });
}

// Delete
export async function clearCache(key) {
    await orchestratorDb.cache.delete(key);
}